import { useOnlineStatus } from "@ths/shared";
import type { FC } from "react";

const OfflineIndicator: FC = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-amber-500/90 px-4 py-2 text-center text-xs font-medium text-slate-900"
    >
      You&rsquo;re offline. Showing your last loaded reservation.
    </div>
  );
};

export default OfflineIndicator;
